import { render, staticRenderFns } from "./Kong.vue?vue&type=template&id=282b94ce&scoped=true"
import script from "./Kong.vue?vue&type=script&lang=js"
export * from "./Kong.vue?vue&type=script&lang=js"
import style0 from "./Kong.vue?vue&type=style&index=0&id=282b94ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282b94ce",
  null
  
)

export default component.exports